export function getCoords(elem: Element) {
  const box = elem.getBoundingClientRect();

  const body = document.querySelector(".atc-graph");
  const clientTop = body.getBoundingClientRect().top || 0;
  const clientLeft = body.getBoundingClientRect().left || 0;

  const top = box.top - clientTop;
  const left = box.left - clientLeft;
  return {
    top: Math.round(top),
    left: Math.round(left),
    width: box.width,
    height: box.height,
    clientTop,
    clientLeft
  };
}
